import _isEmpty from 'underscore/cjs/isEmpty.js'

export const useAuthorStore = defineStore('author', {
  state: () => {
    return {
      authors: [],
      authorByCategory: {},
      featuredAuthors: [],
      author: {}
    }
  },

  getters: {
    videos: state => state.author?.videos?.items ?? [],

    publications: state => state.author?.publications?.items ?? [],

    profileSchemaList: state => {
      return Object.values(state.authorByCategory ?? {})
        .flatMap(category => category?.items ?? [])
        .map(({ name, url, jobTitle }) => ({ name, url, jobTitle }))
    }
  },

  actions: {
    getAuthorsByCategory ({
      offset = 0,
      limit = 3,
      categories = []
    } = {}) {
      return useFetch('/api/contentful/authors/by-category', {
        method: 'post',
        body: {
          preview: false,
          offset,
          limit,
          categories
        }
      }).then(res => {
        if (!_isEmpty(res?.error.value)) {
          throw(res?.error.value?.data)
        }

        const data = res?.data.value ?? {}

        this.authorByCategory = data

        return data
      }).catch(err => {
        throw(err)
      })
    },

    getAuthorsByCategoryPage ({
      category,
      offset = 0,
      limit = 3
    } = {}) {
      return useFetch('/api/contentful/authors/by-category', {
        method: 'post',
        body: {
          preview: false,
          offset,
          limit,
          categories: [category]
        }
      }).then(res => {
        if (!_isEmpty(res?.error.value)) {
          throw(res?.error.value?.data)
        }

        const data = res?.data.value ?? {}
        const [key, value] = Object.entries(data)[0] ?? []

        if (key) {
          this.authorByCategory = {
            ...this.authorByCategory,
            [key]: value
          }
        }

        return value
      }).catch(err => {
        throw(err)
      })
    },

    getFeaturedAuthors ({
      offset = 0,
      limit = 3
    } = {}) {
      return useFetch('/api/contentful/authors/featured', {
        method: 'post',
        body: {
          preview: false,
          offset,
          limit
        }
      }).then(res => {
        if (!_isEmpty(res?.error.value)) {
          throw(res?.error.value?.data)
        }

        const data = res?.data.value ?? []

        this.featuredAuthors = data

        return data
      }).catch(err => {
        throw(err)
      })
    },

    getAuthor (slug) {
      return useFetch(`/api/contentful/authors/author/${slug}`, {
        method: 'post',
        body: {
          preview: false
        }
      }).then(res => {
        if (!_isEmpty(res?.error.value)) {
          throw(res?.error.value?.data)
        }

        const data = res?.data.value ?? {}

        this.author = data

        return data
      }).catch(err => {
        throw(err)
      })
    }
  }
})
